import PropTypes from 'prop-types'

import FeedArticles from '@adv-mt/mt-feed-articles'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

import LinkFactory from '../../../../../components/LinkFactory/index.js'
import {NEWS_DETAIL_BASE_CLASS} from '../../config.js'

export const SidebarRelatedContent = ({title, newsFeed, renderCardActions}) => {
  return (
    <div className={`${NEWS_DETAIL_BASE_CLASS}-relatedContent`}>
      <div className={`${NEWS_DETAIL_BASE_CLASS}-relatedContentHeader`}>
        <TitleBasic as={titleBasicTags.h2} size={titleBasicSizes.xs} title={title} />
      </div>
      <FeedArticles initialNewsSearchFeed={newsFeed} linkFactory={LinkFactory} renderCardActions={renderCardActions} />
    </div>
  )
}

SidebarRelatedContent.propTypes = {
  title: PropTypes.string.isRequired,
  newsFeed: PropTypes.object.isRequired,
  renderCardActions: PropTypes.func
}
